<template>
  <van-pull-refresh v-model="refreshing" @refresh="onRefresh" class="special_detail_container">
    <van-list v-model="loading" :offset="10" :immediate-check="false" :finished="finished" finished-text="没有更多了" @load="onLoadMore">
      <div class="special_info" v-if="!!specialInfo">
        <!-- 默认大图 -->
        <div class="special_detault_img" v-if="specialInfo.indexBackMode == 0">
          <div class="img">
            <img :src="specialInfo.bigResouceUrl" :onerror="imgLoadError(specialInfo)" alt="" />
          </div>
        </div>
        <!-- 背景海报、多张 -->
        <div class="special_poster_imgs" v-else-if="specialInfo.indexBackMode == 1 && specialInfo.backPosterPicArray.length>0" :style="{ height: posterHeight }">
          <div class="swipe_box">
            <van-swipe :show-indicators="true" :loop="true" :autoplay="3000">
              <van-swipe-item v-for="(item, index) in specialInfo.backPosterPicArray" :key="index">
                <div class="img" :style="{backgroundImage:'url(' +(item.picUrl == ''? require('@/assets/images/user_default.png'): item.picUrl) +')',}"></div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
        <!-- 背景方图、多张 -->
        <div class="special_block_imgs" v-else-if="specialInfo.indexBackMode == 2 && specialInfo.backBlockPicArray.length>0">
          <div class="swipe_box">
            <van-swipe :show-indicators="true" :loop="true" :autoplay="3000">
              <van-swipe-item v-for="(item, index) in specialInfo.backBlockPicArray" :key="index">
                <div class="img" :style="{backgroundImage:'url(' +(item.picUrl == ''? require('@/assets/images/user_default.png'): item.picUrl) +')',}"></div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
        <!-- 普通大图、多张 -->
        <div class="special_normal_imgs" v-else-if="specialInfo.indexBackMode == 3 && specialInfo.backNormalPicArray.length>0">
          <div class="swipe_box">
            <van-swipe :show-indicators="true" :loop="true" :autoplay="3000">
              <van-swipe-item v-for="(item, index) in specialInfo.backNormalPicArray" :key="index">
                <div class="img" :style="{backgroundImage:'url(' +(item.picUrl == ''? require('@/assets/images/user_default.png'): item.picUrl) +')',}"></div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
        <!-- 默认大图 -->
        <div class="special_detault_img" v-else>
          <div class="img">
            <img :src="specialInfo.bigResouceUrl" :onerror="imgLoadError(specialInfo)" alt="" />
          </div>
        </div>
      </div>
      <news-list class="special_news_list" :contentList="specialNewsList"></news-list>
    </van-list>
  </van-pull-refresh>
</template>
<script>
import { mapState } from "vuex";
import { loadStat, clickPlayCount } from "@/utils";
import specialApi from "@/api/apis/special.js";
import commApi from "@/api/apis/common.js";
import NewsList from "./components/SpecialColumnNewsList";
export default {
  name: "SpecialDetail",
  components: {
    NewsList,
  },
  data() {
    return {
      posterHeight: 'auto',
      refreshing: false,
      loading: false,
      finished: false,
      params: {
        contentId: null,
        memberId: null,
        pageNo: 0,
        pageSize: 20,
        sourceType: 4, //1:苹果;2:安卓;3web;4:H5
      },
      specialInfo: null,
      specialNewsList: [], //专栏新闻列表
      shareUrl: "",
    };
  },
  computed: {
    ...mapState("app", ["userInfo", "nodeCode"]),
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == "/index_share") {
        vm.shareUrl = location.href.replace("/column_detail?", "/index_share?");
      } else {
        vm.shareUrl = location.href;
      }
    });
  },
  methods: {
    imgLoadError(item) {
      // console.log("加载默认图片");
    },
    /* 微信二次分享 */
    wechatShare() {
      var _this = this;

      commApi.getWeiXinTicket({
        nodeCode: _this.nodeCode,
        url: _this.shareUrl
      }).then((res) => {
        var shareImgurl = "";
        if (!!_this.specialInfo.imgUrl && _this.specialInfo.imgUrl.length > 0) {
          shareImgurl = _this.specialInfo.imgUrl;
        } else if (!!_this.specialInfo.bigResouceUrl && _this.specialInfo.bigResouceUrl.length > 0) {
          shareImgurl = _this.specialInfo.bigResouceUrl;
        }
        _this.$WeiXin.shareWeiXin(res, "专栏|" + _this.specialInfo.specialTitle, _this.specialInfo.introduction, _this.shareUrl, shareImgurl);
      }).catch((err) => {

      })
    },
    /* 获取专栏 */
    getSpecialContentsForColumn() {
      var _this = this;

      specialApi
        .getSpecialContentsForColumn(_this.params)
        .then((res) => {
          _this.refreshing = false;
          _this.loading = false;
          if (res.suc == 1) {
            document.title = res.data.specialTitle;

            if (_this.params.pageNo == 0) {
              _this.specialNewsList = res.data.contents;
              _this.specialInfo = res.data;
              _this.wechatShare(); // 微信二次分享
              _this.statistics(); // 统计
            } else {
              _this.specialNewsList = _this.specialNewsList.concat(
                res.data.contents
              );
            }
            if (res.data.contents.length < _this.params.pageSize) {
              _this.finished = true;
            }
          } else {
            _this.$toast({
              message: res.message || res.text,
              position: "center",
            });
          }
        })
        .catch((err) => {
          _this.$toast({
            message: "接口调用出错",
            position: "center",
          });
        });
    },
    /* 下拉刷新 */
    onRefresh() {
      this.params.pageNo = 0;
      // this.specialNewsList = [];
      if (this.finished) {
        this.refreshing = false;
      } else {
        this.refreshing = true;
      }
      this.loading = false;
      this.finished = false;
      this.getSpecialContentsForColumn(); // 获取专栏
    },
    /* 上拉加载 */
    onLoadMore() {
      this.params.pageNo++;
      this.loading = true;
      this.getSpecialContentsForColumn(); // 获取专栏
    },
    /* 统计 */
    statistics() {
      let tj_params = {
        contentCreationTime: this.specialInfo.contentCreationTime, // 创建时间
        contentId: this.specialInfo.id, // 专题Id
        contentTitle: this.specialInfo.specialTitle,
        contentType: 7,
        memberId: this.specialInfo.memberId, // 当前稿件的编辑者的id
        nickName: this.specialInfo.nickName, // 当前稿件的编辑者的用户名称
      }
      if (!!this.specialInfo.channelId && this.specialInfo.channelId > 0) {
        tj_params = Object.assign(tj_params, {
          channelId: this.specialInfo.channelId, // 栏目id
          channelName: this.specialInfo.channelName, // 栏目名称
        });
      }
      clickPlayCount(tj_params);
    },
  },
  created() {
    let query = this.$route.query;
    if (Object.prototype.hasOwnProperty.call(query, "contentId")) {
      this.params.contentId = Number(query.contentId);
      if (!!this.userInfo) {
        this.params.memberId = this.userInfo.id;
      }
      this.getSpecialContentsForColumn(); // 获取专栏
      loadStat(); // 友盟统计
    } else {
      this.$router.replace({
        path: "/error",
      });
    }
  },
  updated() {
    var ele1 = document.getElementsByClassName("top_header");
    let h1 = 0;
    if (ele1.length > 0) {
      h1 = ele1[0].clientHeight;
    }
    this.posterHeight = window.innerHeight - h1 + "px";
  },
};
</script>
<style scoped lang="scss">
.special_detail_container {
  width: 100%;
  height: 100%;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
  .special_info {
    background-color: #fff;
    /* 默认大图 */
    .special_detault_img {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%;
      background-repeat: no-repeat;
      background-size: cover;
      background-position: center center;
      background-image: url(~@/assets/images/default_pic_16_9.png);
      overflow: hidden;
      .img {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 1;
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        img {
          object-fit: cover;
          min-width: 100%;
          min-height: 100%;
        }
      }
    }
    /* 海报 */
    .special_poster_imgs {
      position: relative;
      width: 100%;
      height: 100%;
      overflow: hidden;
      .swipe_box {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        .van-swipe {
          width: 100%;
          height: 100%;
          .van-swipe-item {
            .img {
              width: 100%;
              height: 100%;
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }
          }
        }
      }
    }
    /* 方图 */
    .special_block_imgs {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 100%;
      overflow: hidden;
      .swipe_box {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        .van-swipe {
          width: 100%;
          height: 100%;
          .van-swipe-item {
            .img {
              width: 100%;
              height: 100%;
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }
          }
        }
      }
    }
    /* 普通大图 */
    .special_normal_imgs {
      position: relative;
      width: 100%;
      height: 0;
      padding-bottom: 56.25%;
      overflow: hidden;
      .swipe_box {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        .van-swipe {
          width: 100%;
          height: 100%;
          .van-swipe-item {
            .img {
              width: 100%;
              height: 100%;
              background-repeat: no-repeat;
              background-position: center;
              background-size: cover;
            }
          }
        }
      }
    }
  }
  .special_news_list {
    padding: 0 15px;
  }
}
</style>